<div class="responsive-card gap-4">
  <div i18n class="responsive-card-title">Age for Minimum Calculation</div>
  <ng-container>
    <div class="min-age-grid">
      <div *ngFor="let row of minAgeRows" class="inner-card d-flex flex-column gap-3">
        <div class="d-flex align-items-center gap-2">
          <div *ngIf="row.jurisdictionName; else nonLockedInName" class="label-sm">{{ row.jurisdictionName }}</div>
          <ng-template #nonLockedInName><div class="label-sm" i18n>Non-Locked-In</div></ng-template>
          <app-status-pill *ngIf="row.isNew" [statusPill]="newStatusPill" />
        </div>
        <hr class="m-0" />
        <div class="d-flex justify-content-between">
          <div class="d-flex flex-column gap-2">
            <div class="label-sm">{{ row.personName }}</div>
            <div class="value">
              <span *ngIf="row.isSpouse; else memberRole" i18n>Spouse</span>
              <ng-template #memberRole><span i18n>Member</span></ng-template>
            </div>
          </div>
          <div class="d-flex flex-column gap-2">
            <div class="label-sm text-end" i18n>Age: {{ row.age }}</div>
            <div class="value">{{ row.dateOfBirth | date : 'MMM d, yyyy' }}</div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
